export enum API_ENVIRONMENTS {
    DEV = 'development',
    STAGE = 'stage',
    PROD = 'production'
}

// Timeout & interval durations (in milliseconds)
export const DASHBOARD_READY_CHECK_INTERVAL = 100;
export const DASHBOARD_READY_TIMEOUT = 5000;

// Assets
export const DART_USER_GUIDE = '/assets/DART_USER_GUIDE.pdf';
export const DART_LOGO = '/assets/dart-logo.png';

/** Centralised app route paths — single source of truth for navigation. */
export const ROUTES = {
  HOME: '/',
  USER_ACCESS: '/user-access',
  USER_ACTIVITY: '/user-activity',
} as const;

// ─── User Access Management ──────────────────────────────────────────────────

/** Allowed Cognito group names — only two roles are supported. */
export const USER_ACCESS_ROLES = {
  ADMIN: 'admin',
  USER:  'user',
} as const;

/** Union type derived from the role map — keeps types and values in sync. */
export type UserRole = typeof USER_ACCESS_ROLES[keyof typeof USER_ACCESS_ROLES];

/** Options list used by the role <Select> in AddUserModal. */
export const USER_ROLE_OPTIONS: ReadonlyArray<{ value: UserRole; label: string }> = [
  { value: USER_ACCESS_ROLES.USER,  label: 'User'  },
  { value: USER_ACCESS_ROLES.ADMIN, label: 'Admin' },
] as const;

/**
 * Maps a Cognito UserStatus string (lower-cased) to an MUI Chip colour.
 * Any status not listed defaults to 'default' (grey).
 */
export const USER_STATUS_COLOR_MAP: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
  confirmed:             'success',
  unconfirmed:           'warning',
  force_change_password: 'warning',
  archived:              'error',
  compromised:           'error',
  reset_required:        'error',
};

/** Pagination defaults for the User Access table. */
export const USER_ACCESS_PAGINATION = {
  DEFAULT_ROWS_PER_PAGE:   10,
  ROWS_PER_PAGE_OPTIONS:   [5, 10, 25, 50],
} as const;

/** Visual constants for the User Access table container. */
export const USER_TABLE_STYLE = {
  MAX_HEIGHT:        400,
  STATUS_COL_WIDTH: '150px',
  BORDER_LOADING:   '2px solid #1976d2',
  BORDER_NORMAL:    '1px solid rgba(224, 224, 224, 1)',
} as const;